// Shared vocabulary for the Help Desk (backend: routers/help_desk.py).
// Labels are written for the person who filed the request, not for engineers.

export const STATUS = {
  new: { label: "New", tone: "border-border text-foreground", hint: "Waiting for review" },
  needs_info: { label: "Needs an answer", tone: "border-terracotta-200 text-terracotta-700", hint: "An approver asked a question" },
  approved: { label: "In progress", tone: "border-estate-200 text-estate-700", hint: "Approved, a person is on it" },
  claude: { label: "Claude is working", tone: "border-estate-200 text-estate-700 bg-estate-50", hint: "Claude is making the change" },
  review: { label: "Ready for review", tone: "border-estate-200 text-estate-700 bg-estate-50", hint: "Claude's change needs a review before it ships" },
  shipped: { label: "Shipped — check it", tone: "border-estate-200 text-estate-700 bg-estate-100", hint: "Live in HQ; the requester checks it off" },
  done: { label: "Done", tone: "border-border text-muted-foreground", hint: "Checked off" },
  declined: { label: "Declined", tone: "border-border text-muted-foreground", hint: "Not going ahead" },
};

export const CATEGORY = {
  bug: "Something's broken",
  feature: "New feature or tool",
  change: "Change how something works",
  access: "Access or permissions",
  data: "Fix data or a record",
  question: "Question",
  other: "Other",
};

export const URGENCY = {
  low: "Whenever",
  normal: "Normal",
  high: "Soon — it's slowing me down",
  urgent: "Urgent — I'm blocked",
};

export const AREAS = [
  "Client Calculator & proposals",
  "Intake & new projects",
  "Projects",
  "Client tracker",
  "Money & payments",
  "Change orders & upsells",
  "Studio & resources",
  "Meetings & calendar",
  "Login & access",
  "Other",
];

export function StatusPill({ status, className = "" }) {
  const s = STATUS[status] || STATUS.new;
  return (
    <span
      title={s.hint}
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[12px] ${s.tone} ${className}`}
    >
      {s.label}
    </span>
  );
}

export function fullTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function ago(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 86400 * 7) return `${Math.floor(s / 86400)}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
